module.exports = __webpack_public_path__ + "img/data-pelanggaran.80660073.svg";